import { create } from 'zustand'
import { JobStatus } from '@/types/jobs'

const DEFAULT_STATUS_FILTER: JobStatus | null = JobStatus.ACTIVE

interface JobsFilterStore {
    searchQuery: string
    setSearchQuery: (query: string) => void
    statusFilter: JobStatus | null
    setStatusFilter: (status: JobStatus | null) => void
    clearFilters: () => void
    hasActiveFilters: () => boolean
}

export const useJobsFilterStore = create<JobsFilterStore>()((set, get) => ({
    searchQuery: '',
    setSearchQuery: query => set({ searchQuery: query }),

    statusFilter: DEFAULT_STATUS_FILTER,
    setStatusFilter: status => set({ statusFilter: status }),

    clearFilters: () => set({ searchQuery: '', statusFilter: null }),

    hasActiveFilters: () => {
        const state = get()
        return state.searchQuery !== '' || state.statusFilter !== null
    },
}))

export const useJobsSearchQuery = () => useJobsFilterStore(state => state.searchQuery)
export const useJobsStatusFilter = () => useJobsFilterStore(state => state.statusFilter)
export const useSetJobsSearchQuery = () => useJobsFilterStore(state => state.setSearchQuery)
export const useSetJobsStatusFilter = () => useJobsFilterStore(state => state.setStatusFilter)
export const useClearJobsFilters = () => useJobsFilterStore(state => state.clearFilters)
export const useHasActiveJobsFilters = () => useJobsFilterStore(state => state.hasActiveFilters())
